<!-- The DS status chip: a 4px-radius outline with a leading glyph, the label always `Text/primary`.
     The frame is 1px where the design asks for `Stroke/default-xs`; `border-xs` now expresses that
     exactly, and switching to it is a visual change across every screen carrying this chip, so it
     is left for a decision rather than taken here. -->
<span
  class="inline-flex items-center gap-0.5 rounded border border-solid text-title align-middle"
  [ngClass]="[colors[status], size === 'lg' ? 'px-2 py-1 text-body-md' : 'px-1 py-0.5 text-caption-sm']"
>
  <mat-icon
    [svgIcon]="icons[status]"
    class="shrink-0"
    [ngClass]="size === 'lg' ? '!w-4 !h-4' : '!w-3 !h-3'"
  ></mat-icon>
  <span>{{ labels[status] }}</span>
</span>
